import { getOutlineImageCanvasContext } from './getOutlineImageCanvasContext';
import { TempImageFactory } from './TempImageFactory';

const MAX_NUM_SCALING_STEPS = 3;

export type ReduceImageOnCanvasParams = {
  canvasImageSource: HTMLCanvasElement;
  width: number;
  height: number;
};

/**
 * Taken from in pdf.js/web/pdf_thumbnail_view.js #reduceImage
 */
export const reduceImageOnCanvas = ({
  canvasImageSource,
  width,
  height,
}: ReduceImageOnCanvasParams): HTMLCanvasElement | undefined => {
  const { ctx, canvas } = getOutlineImageCanvasContext({ enableHMA: true, height, upscaleFactor: 1, width });

  if (!ctx) {
    return;
  }

  if (canvasImageSource.width <= 2 * canvas.width) {
    ctx.drawImage(
      canvasImageSource,
      0,
      0,
      canvasImageSource.width,
      canvasImageSource.height,
      0,
      0,
      canvas.width,
      canvas.height,
    );
    return canvas;
  }
  // drawImage does an awful job of rescaling the image, doing it gradually.
  let reducedWidth = canvas.width << MAX_NUM_SCALING_STEPS;
  let reducedHeight = canvas.height << MAX_NUM_SCALING_STEPS;
  const { canvas: reducedImage, context: reducedImageCtx } = TempImageFactory.getCanvas(reducedWidth, reducedHeight);

  if (!reducedImageCtx || !reducedImage) {
    return;
  }

  while (reducedWidth > canvasImageSource.width || reducedHeight > canvasImageSource.height) {
    reducedWidth >>= 1;
    reducedHeight >>= 1;
  }
  reducedImageCtx.drawImage(
    canvasImageSource,
    0,
    0,
    canvasImageSource.width,
    canvasImageSource.height,
    0,
    0,
    reducedWidth,
    reducedHeight,
  );
  while (reducedWidth > 2 * canvas.width) {
    reducedImageCtx.drawImage(
      reducedImage,
      0,
      0,
      reducedWidth,
      reducedHeight,
      0,
      0,
      reducedWidth >> 1,
      reducedHeight >> 1,
    );
    reducedWidth >>= 1;
    reducedHeight >>= 1;
  }
  ctx.drawImage(reducedImage, 0, 0, reducedWidth, reducedHeight, 0, 0, canvas.width, canvas.height);
  return canvas;
};
